<!--
    描述：签署区域列表数据
    日期：2022/06/27
    作者：张卫华
-->
<template>
  <div class="tab-main-page">
    <div class="main-content">
      <el-row>
        <el-col :span="12">
          <span style="font-weight: bold">签署方信息：</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            是否制定签署区域位置：true-固定签署区位置且无法移动，false-不固定签署区位置且签署时可自由移动
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            是否自动执行签署：true-自动签署，false-手动签署。
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            签署也是否显示图片章：显示 - true;关闭显示 - false
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            企业主体签约类型：0-个人盖章，2-机构盖章；
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            印章ids：印章id1","印章id2",....
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            印章ID：印章编号
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            指定业务印章类型：ALL -不指定印章类型，COMMON -无业务类型(其他)，CONTRACT -合同专用章，FINANCE -财务章，PERSONNEL -人事专用章，PUBLIC -公章
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            签署方式：0-手绘签名  ，1-模板印章签名，
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            签章日期格式:yyyy-MM-dd,yyyy/MM/dd,yyyy年MM月dd日（默认值）
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            是否需要添加签署日期：0-禁止 1-必须 2-不限制，
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            签署区的宽度：
          </span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name : 'detail_tab_sali',
  components: {

  },
  data() {
    return {

    }
  },
  mounted() {},
  computed: {},
  // 进入缓存页面
  activated() {

  },
  watch: {},
  created() {},
  methods: {

  }
}
</script>
<style lang="less" scoped>
.tab-main-page {
  .main-content {
    font-family: 'Arial Normal', 'Arial';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    color: #333333;
    line-height: normal;

    .el-row {
      padding : 10px 0px;
    }
  }
}
</style>